// extracted by mini-css-extract-plugin
module.exports = {"image":"PictureHtmlImage_image__O8WgI","isLook":"PictureHtmlImage_isLook__2HRYt"};